import { fmtDateTime, money } from "../lib/api";

export default function ReceiptPrint({ sale, storeName = "iRepair POS" }) {
  if (!sale) return null;
  const when = fmtDateTime(sale.created_at);
  return (
    <div id="printable-receipt" className="hidden print:block">
      <div style={{ textAlign: "center", fontWeight: 700, fontSize: 14 }}>{storeName}</div>
      <div style={{ textAlign: "center", fontSize: 10 }}>Sales Receipt</div>
      <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10 }}>
        <span>{sale.sale_number}</span><span>{when}</span>
      </div>
      <div style={{ fontSize: 10 }}>Cashier: {sale.cashier_name}</div>
      {sale.customer_name ? <div style={{ fontSize: 10 }}>Customer: {sale.customer_name}</div> : null}
      <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
      {sale.items.map((it, idx) => (
        <div key={idx} style={{ marginBottom: 4 }}>
          <div style={{ fontSize: 11, fontWeight: 600 }}>{it.name}</div>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10 }}>
            <span>{it.quantity} x ${money(it.unit_price)}</span>
            <span>${money(it.line_total)}</span>
          </div>
        </div>
      ))}
      <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
      <Line k="Subtotal" v={`$${money(sale.subtotal)}`} />
      {sale.discount > 0 && <Line k="Discount" v={`-$${money(sale.discount)}`} />}
      {sale.tax > 0 && <Line k="Tax" v={`$${money(sale.tax)}`} />}
      <Line k="TOTAL" v={`$${money(sale.total)}`} bold />
      {(() => {
        // When more than one payment was taken (split tender) show every
        // method line so cashier + customer both see the cash/card/Tyro
        // breakdown on the receipt — this is a Tyro cert requirement for
        // integrated receipts and also plain good UX.
        const payments = (sale.payments || []).filter((p) => p && Number(p.amount) > 0);
        if (payments.length >= 2) {
          return (
            <>
              {payments.map((p, idx) => {
                const label = (p.method || "").replace("_", " ").toUpperCase();
                const tyro = p.tyro_meta || {};
                return (
                  <div key={idx} style={{ marginTop: 2 }}>
                    <Line k={label} v={`$${money(p.amount)}`} />
                    {p.method === "tyro" && tyro.authorisation_code && (
                      <div style={{ fontSize: 9, color: "#333", paddingLeft: 6 }}>
                        {(tyro.card_type || "").toUpperCase()} {tyro.elided_pan || ""} · Auth {tyro.authorisation_code}
                        {tyro.rrn ? ` · RRN ${tyro.rrn}` : ""}
                      </div>
                    )}
                  </div>
                );
              })}
              <Line k="Tendered total" v={`$${money(sale.amount_tendered)}`} />
            </>
          );
        }
        return (
          <Line k={`Tendered (${(sale.payment_method || "").replace("_", " ")})`} v={`$${money(sale.amount_tendered)}`} />
        );
      })()}
      <Line k="Change" v={`$${money(sale.change_due)}`} />
      {/* Cardholder signature indicator — Tyro cert Signature workflow. */}
      {sale.tyro_signature_required && (
        <div style={{ textAlign: "center", marginTop: 8, fontSize: 10 }}>
          <div style={{ fontWeight: 700 }}>*** CARDHOLDER SIGNED ***</div>
          <div style={{ fontSize: 9, marginTop: 2 }}>Signature on file  x_______________________</div>
        </div>
      )}
      <div style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
      <div style={{ textAlign: "center", fontSize: 10 }}>Thank you!</div>
      <div style={{ textAlign: "center", fontSize: 9, marginTop: 2 }}>All sales final unless otherwise noted.</div>
    </div>
  );
}

function Line({ k, v, bold }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", fontSize: bold ? 13 : 11, fontWeight: bold ? 700 : 400 }}>
      <span>{k}</span><span>{v}</span>
    </div>
  );
}
